// extracted by mini-css-extract-plugin
export default {"menuBlock":"aG-z","title":"bG-z","nav":"cG-z","flexCell":"dG-z","facetLink":"eG-z"};